<template>
  <el-dialog title="发送记录" :visible.sync="visible" width="80%">
    <section v-loading="listLoading" class="page-container">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.email" placeholder="邮件"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="list">刷新</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent">
        <el-table
          height="500px"
          :data="results"
          highlight-current-row
          border
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="emailSendId" label="发送任务ID"></el-table-column>
          <el-table-column prop="email" label="邮箱地址"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template #default="{ row }">
              {{
                row.status === 0
                  ? "待发送"
                  : row.status === 1
                  ? "发送成功"
                  : row.status === 2
                  ? "发送失败"
                  : "取消发送"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="sendTime" label="发送时间">
            <template #default="{ row }">{{ row.sendTime | formatDate }}</template>
          </el-table-column>
          <el-table-column prop="errorInfo" label="错误信息"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template #default="{ row }">{{ row.createTime | formatDate }}</template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </section>
  </el-dialog>
</template>

<script>
import MyPagination from "@/components/MyPagination";
export default {
  name: "EmailSendLog",
  components: { MyPagination },
  data() {
    return {
      visible: false,
      results: [],
      listLoading: false,
      page: {},
      filters: {
        emailSendId: 0,
        email: "",
      },
    };
  },
  mounted() {},
  methods: {
    async show(emailSendId) {
      this.visible = true;
      this.filters.emailSendId = emailSendId;
      this.filters.email = "";
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/email-send-log/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
